import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-data-table-root': {
    marginTop: 'var(--abyss-space-sm)',
  },
  '.remediation-assignments-retryInterval': {
    '.remediation-assignments-retryIntervalUnit': {
      '&.abyss-select-input-root': {
        width: '105px',
      },
      border: 'none',
    },
  },
  '.remediation-assignments-retryInterval.abyss-text-input-left-add-on': {
    padding: 0,
  },
  '#removeField': {
    '.abyss-icon': {
      color: 'var(--abyss-colors-error1)',
      marginRight: 'var(--abyss-space-xs)',
      marginTop: 'var(--abyss-space-xs)',
    },
    '&:hover': {
      'span.abyss-icon-symbol:first-of-type': {
        color: 'var(--abyss-colors-error1)',
        display: 'inline-block',
        visibility: 'visible',
      },
      'span.abyss-icon-symbol:last-of-type': {
        display: 'none',
        visibility: 'hidden',
      },
    },
    color: 'var(--abyss-colors-error1)',
    fontWeight: 'bold !important',
    'span.abyss-icon-symbol:first-of-type': {
      display: 'none',
      visibility: 'hidden',
    },
    'span.abyss-icon-symbol:last-of-type': {
      display: 'inline-block',
      visibility: 'visible',
    },
  },
  td: {
    padding:
      'calc(var(--abyss-space-lg) - 5px) var(--abyss-space-md) calc(var(--abyss-space-lg) + 5px) var(--abyss-space-md)',
  },
});
